module.exports = __webpack_public_path__ + "img/Steor-Icon-04.27978648.svg";